import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  ListItem,
  ListItemAvatar,
  ListItemText,
  Tooltip,
  Box,
  Typography,
} from '@mui/material';
import {
  PictureAsPdf as PictureAsPdfIcon,
  InsertDriveFile as InsertDriveFileIcon,
  Image as ImageIcon,
  Message as MessageIcon,
} from '@mui/icons-material';
import { FileWordOutlined } from '@ant-design/icons';

const DocumentItem = ({ document, handleClikOption }) => {
  const hasNotes = document?.notas && document.notas.length > 0;

  // Estilo para las comillas decorativas
  const quoteStyle = {
    fontSize: '2rem',
    fontWeight: 'bold',
    color: '#148f9f',
    lineHeight: 0,
    fontFamily: 'serif',
    display: 'inline-block',
    verticalAlign: 'middle',
  };

  const renderIconFile = (document) =>{
    const documentExtention = document.Nombre.substring(document.Nombre.lastIndexOf(".") + 1);
    switch (documentExtention) {
      case 'docx':
      case 'doc':
      case 'dot':
      case 'dotx':
        return <FileWordOutlined style={{ color: '#436170', fontSize: '35px' }} />;
      case 'png':
      case 'jpeg':
      case 'jpg':
        return <ImageIcon sx={{ color: '#436170', fontSize: '35px' }} />;
      case 'pdf':
        return <PictureAsPdfIcon sx={{ color: '#cb5959', fontSize: '35px' }} />
      default:
        return <InsertDriveFileIcon sx={{ color: '#436170', fontSize: '35px' }} />;
    }
  };

  const handleClickModal = (document)=>{
    handleClikOption(document);
  };

  return (
<Tooltip
      title={
        hasNotes ? (
          <Box sx={{ p: 1, width: 380 }}>
            {/* Barra de acento superior */}
            <Box sx={{ height: 4, width: 60, backgroundColor: '#148f9f', borderRadius: 4, mb: 2 }} />
            
            {/* Contenedor con Scroll */}
            <Box 
              sx={{ 
                display: 'block', 
                maxHeight: 200, 
                overflowY: 'auto', 
                pr: 1.5,
                '&::-webkit-scrollbar': { width: 6 },
                '&::-webkit-scrollbar-thumb': { background: 'rgba(20, 143, 159, 0.4)', borderRadius: 10 },
                scrollbarWidth: 'thin',
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
                <MessageIcon sx={{ color: '#cccccc', fontSize: '1.2rem', mt: 0.3, flexShrink: 0 }} />
                <Typography 
                  variant="body2" 
                  sx={{ 
                    color: '#333333', 
                    lineHeight: 1.7, 
                    fontSize: '0.92rem', 
                    whiteSpace: 'pre-wrap', 
                    wordBreak: 'break-word' 
                  }}
                >
                  <Box component="span" sx={{ ...quoteStyle, mr: 0.5 }}>“</Box>
                  {document.notas}
                  <Box component="span" sx={{ ...quoteStyle, ml: 0.5 }}>”</Box>
                </Typography>
              </Box>
            </Box>
          </Box>
        ) : ""
      }
      disableHoverListener={!hasNotes}
      arrow
      placement="right"
      enterDelay={350}
      componentsProps={{
        tooltip: {
          sx: {
            backgroundColor: '#fbfdfd',
            boxShadow: '0 10px 30px rgba(0,0,0,0.15)',
            border: '1px solid rgba(20, 143, 159, 0.2)',
            borderRadius: '12px',
            padding: '12px',
            maxWidth: 420,
            color: 'inherit',
            whiteSpace: 'normal',
            '& .MuiTooltip-arrow': {
              color: '#fbfdfd',
              '&::before': { border: '1px solid rgba(20, 143, 159, 0.2)' }
            }
          }
        }
      }}
    >
      {/* Envolvemos el ListItem. El componente="div" ayuda a evitar conflictos de refs */}
      <ListItem 
        onClick={() => handleClickModal(document)}
        sx={{
          cursor: 'pointer',
          borderBottom: '1px solid #dfdfdf',
          '&:hover': {
            backgroundColor: '#f5f5f5',
          },
        }}
      >
        <ListItemAvatar>
          {renderIconFile(document)}
        </ListItemAvatar>
        
        <ListItemText 
          primary={document.NombreMultimedia} 
          secondary={
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Box sx={{ display: 'flex' }}>
                  <Typography variant="body2" display="block"
                  sx={{
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    width: 300,
                    color: '#666666',
                  }}>
                    {document.notas}
                  </Typography>
                  {/* Mostramos el icono de mensaje también en la lista si hay notas */}
                  {hasNotes && <MessageIcon sx={{ color: '#028b9d78', fontSize: '1.2rem', marginLeft: '5px' }} />}
              </Box>
              <Typography variant="caption" display="block">
                {document.Fecha}
              </Typography>
            </Box>
          } 
        />
      </ListItem>
    </Tooltip>
  );
}

DocumentItem.propTypes = {
  document: PropTypes.object.isRequired,
  handleClikOption: PropTypes.func.isRequired,
};

export default DocumentItem;
